import { c as _c } from "react/compiler-runtime";
import type { ThemeFestival } from '@/app/(allowed)/festival/_utils/festivalFetchers';
import { FestivalCard } from '@/components/server';
import { ROUTES } from '@/constants';
import { FestivalCardSkeleton } from '../FestivalSearch/FestivalCardSkeleton';
import { HorizontalSlider } from './HorizontalSlider';
import { SectionHeader } from './SectionHeader';
const PREVIEW_SLIDER_COUNT = 5;
const SLIDE_CLASSNAME = 'max-w-220 flex-[0_0_calc((100%-24px)/2.5)] mobile:min-w-160';
export function FestivalPreviewSection(t0) {
  const $ = _c(13);
  const {
    keyword,
    items,
    totalCount,
    isLoading
  } = t0;
  if (!isLoading && items.length < 1) {
    return null;
  }
  let t1;
  if ($[0] !== keyword) {
    t1 = ROUTES.SEARCH.withSearchParams({
      searchParams: {
        q: keyword || undefined,
        category: "festival"
      }
    });
    $[0] = keyword;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== totalCount) {
    t2 = <SectionHeader title={"\uB3D9\uB124\uCD95\uC81C"} totalCount={totalCount} moreHref={t1} />;
    $[2] = t1;
    $[3] = totalCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isLoading || $[6] !== items) {
    t3 = isLoading ? Array.from({
      length: PREVIEW_SLIDER_COUNT
    }, _temp) : items.map(_temp2);
    $[5] = isLoading;
    $[6] = items;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <HorizontalSlider className="mobile-tablet:pl-20">{t3}</HorizontalSlider>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <section className="flex w-full flex-col">{t2}{t4}</section>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp2(festival, index_0) {
  return <div key={festival.id ?? index_0} className={SLIDE_CLASSNAME}><FestivalCard festival={festival} /></div>;
}
function _temp(_, index) {
  return <div key={index} className={SLIDE_CLASSNAME}><FestivalCardSkeleton /></div>;
}